import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { requireRoles } from '@/lib/middleware'
import { MyInvoices } from '@/features/my-invoices'

const searchSchema = z.object({
  view: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/_organization/my-invoices/')({
  beforeLoad: async () => {
    await requireRoles(['client', 'primary_contact'])
  },
  validateSearch: searchSchema,
  component: MyInvoices,
})
